import React from 'react';
import Box from '@mui/material/Box';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropsTypes from 'prop-types';
import { getFileSize } from '@crema/utility/Utils';

const FileRow = ({ file, onDeleteUploadFile, onShowAttachment }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                border: (theme) => `solid 1px ${theme.palette.divider}`,
                mb: 2.5,
                borderRadius: 2.5,
                p: 2.5,
                cursor: 'pointer'
            }}
            onClick={onShowAttachment}
        >
            <Box sx={{ mr: 3 }}>
                <InsertDriveFileIcon />
            </Box>
            <Box sx={{ flex: 1 }}>
                <Typography>{file.name}</Typography>
                <Box
                    component='span'
                    sx={{
                        color: 'text.secondary',
                    }}
                >
                    {getFileSize(file.size)}
                </Box>
            </Box>
            <IconButton
                sx={{
                    padding: 1.5,
                    fontSize: 16,
                }}
                onClick={(e) => {
                    e.stopPropagation()
                    onDeleteUploadFile(file)
                }}
            >
                <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>
        </Box>
    );
};

export default FileRow;
FileRow.propTypes = {
    file: PropsTypes.object,
    onDeleteUploadFile: PropsTypes.func,
    onShowAttachment: PropsTypes.func,
};
